"use client"

import {useState} from "react";
import {GlobalRole} from "@/app/auth/roles";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {SidebarMenuButton, useSidebar,} from "@/components/ui/sidebar";
import {ChevronsUpDown, Heart, LogOut, Settings2, Shield,} from "lucide-react";
import {signOut, useSession} from "next-auth/react";
import Link from "next/link";
import {UserInfo} from "@/app/components/UserInfo";
import {UserBadge} from "@/app/components/UserBadge";
import {profilePath} from "@/app/paths";
import {cn} from "@/lib/utils";
import FeedbackForm from "@/app/components/FeedbackForm";

export function NavUser() {
  const {isMobile, state} = useSidebar()
  const collapsed = state === "collapsed"
  const session = useSession()
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const user = session?.data?.user
  if (!user) {
    return null
  }
  const userId = user.id
  const userTooltip = user.name ?? user.email ?? "Account"

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <SidebarMenuButton
          size="lg"
          tooltip={userTooltip}
          className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <div className={cn(
            "flex items-center text-sm leading-tight",
            collapsed ? "justify-center flex-1" : "flex-1 gap-2"
          )}>
            <UserBadge userImage={user?.image}/>
            {!collapsed && <UserInfo id={userId} variant="full" noTooltip className="font-semibold truncate"/>}
          </div>
          {!collapsed && <ChevronsUpDown className="ml-auto size-4"/>}
        </SidebarMenuButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
        side={isMobile ? "bottom" : "right"}
        align="end"
        sideOffset={4}
      >
        <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <div className="flex gap-2 items-center flex-1 text-sm leading-tight">
              <UserBadge userImage={user?.image}/>
              <UserInfo id={userId} variant="full" noTooltip className="font-semibold truncate"/>
            </div>
          </div>
        </DropdownMenuLabel>
        <AdminMenu/>
        <Link href={profilePath()}>
          <DropdownMenuItem className="cursor-pointer">
            <Settings2/> Settings
          </DropdownMenuItem>
        </Link>
        <DropdownMenuItem
          className="cursor-pointer"
          onSelect={(e) => {
            e.preventDefault()
            setFeedbackOpen(true)
          }}
        >
          <Heart className="size-3.5 text-rose-500"/>
          Submit Feedback
        </DropdownMenuItem>
        <FeedbackForm open={feedbackOpen} onOpenChange={setFeedbackOpen}/>
        <DropdownMenuSeparator/>
        <DropdownMenuItem onClick={() => signOut()}>
          <LogOut/> Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

function AdminMenu() {
  const session = useSession()
  if (!session?.data?.user?.globalRoles?.includes(GlobalRole.ADMIN)) {
    return null
  }
  return <Link href="/admin">
    <DropdownMenuItem className="cursor-pointer">
      <Shield/> Admin Menu
    </DropdownMenuItem>
  </Link>
}
